/**
 * The Back Coach mark.
 *
 * Geometry and colour come from the brand system's own `mark-ink.svg`, including
 * its viewBox, rather than from a crop of the raw export.
 *
 * The dot is hard-coded to #C4522A and never inherits. The system is explicit
 * that the dot "marks the point of discomfort; never repurpose it as a status
 * colour", and lists recolouring it among the things not to do. Note it is a
 * distinct terracotta, not the palette's Clay #8E3428, so it cannot be swapped
 * for a token.
 *
 * The body inherits currentColor so the mark works on light and on the petrol
 * surfaces. That is the "Reversed · all white" lockup the system sanctions, with
 * the one exception the system also insists on.
 */
export default function BackCoachIcon({ size = 20 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="108 60 104 116" aria-hidden>
      <path
        d="M206.97,123.7c-1.69-9.07-3.92-22.6-13.7-25.5l-9.64-2.86c-3.66-1.09-7.22-2.25-10.15-4.66s-4.94-6.15-3.36-10.06c1.27,7.87,7.22,9.75,14.45,11.48l9.31,2.23c6.07,2.18,10.47,6.74,12.15,12.97,1.3,5.21,2.27,10.51.95,16.39Z"
        fill="currentColor"
      />
      <path
        d="M146.73,132.23c-8.2-13.15-7.34-27.34-1.15-41.53-4.41,3.45-8.96,5.72-14.16,7.33-14.56,4.51-16.11,10.81-17.83,25.41-3.32-12.85,1.11-23.49,13.43-27.92l10.92-3.93c6.57-3.1,11.18-8.02,13.71-15.06.95,4.49-.71,8.37-2.15,12.22-5.96,15.92-7.27,27.36,1.15,42.37l6.99,12.47c2.49,5.84,4.43,12.29,2.33,18.65-1.27-7.13-2.86-13.36-6.47-19.16l-6.76-10.84Z"
        fill="currentColor"
      />
      <path
        d="M136.67,150.85c2.14,5.94,2.39,12.38.1,18.23-.13-9.84-2.35-17.94-8.05-25.31-6.16-7.96-8.81-17.91-6.61-27.71.95,4.28.83,8.05,1.95,11.9,3.05,10.46,9.64,14.67,12.61,22.9Z"
        fill="currentColor"
      />
      {/* Never recoloured, never tokenised. */}
      <circle cx="160.04" cy="167.42" r="3.71" fill="#C4522A" />
    </svg>
  );
}
